@file:OptIn(InternalResourceApi::class)

package org.maplibre.compose.demoapp.generated

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/org.maplibre.compose.demoapp.generated/"

@delegate:ResourceContentHash(-1_551_973_139)
internal val Res.drawable.arrow_back_24px: DrawableResource by lazy {
      DrawableResource("drawable:arrow_back_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_back_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_050_077_425)
internal val Res.drawable.arrow_drop_down_24px: DrawableResource by lazy {
      DrawableResource("drawable:arrow_drop_down_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_drop_down_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_958_884_665)
internal val Res.drawable.brightness_auto_24px: DrawableResource by lazy {
      DrawableResource("drawable:brightness_auto_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/brightness_auto_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(808_146_345)
internal val Res.drawable.check_24px: DrawableResource by lazy {
      DrawableResource("drawable:check_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/check_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-370_306_731)
internal val Res.drawable.chevron_left_24px: DrawableResource by lazy {
      DrawableResource("drawable:chevron_left_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/chevron_left_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_064_342_824)
internal val Res.drawable.chevron_right_24px: DrawableResource by lazy {
      DrawableResource("drawable:chevron_right_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/chevron_right_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_664_787_951)
internal val Res.drawable.dark_mode_24px: DrawableResource by lazy {
      DrawableResource("drawable:dark_mode_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_mode_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_837_993_428)
internal val Res.drawable.delete_24px: DrawableResource by lazy {
      DrawableResource("drawable:delete_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/delete_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_392_134_212)
internal val Res.drawable.editable_marker_pin: DrawableResource by lazy {
      DrawableResource("drawable:editable_marker_pin", setOf(
        ResourceItem(setOf(), "${MD}drawable/editable_marker_pin.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_844_462_662)
internal val Res.drawable.filter_center_focus_24px: DrawableResource by lazy {
      DrawableResource("drawable:filter_center_focus_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/filter_center_focus_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_989_068_547)
internal val Res.drawable.light_mode_24px: DrawableResource by lazy {
      DrawableResource("drawable:light_mode_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_mode_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_014_918_141)
internal val Res.drawable.location_disabled_24px: DrawableResource by lazy {
      DrawableResource("drawable:location_disabled_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/location_disabled_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_451_709_911)
internal val Res.drawable.location_searching_24px: DrawableResource by lazy {
      DrawableResource("drawable:location_searching_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/location_searching_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_662_039_544)
internal val Res.drawable.map_24px: DrawableResource by lazy {
      DrawableResource("drawable:map_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/map_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_398_653_053)
internal val Res.drawable.my_location_24px: DrawableResource by lazy {
      DrawableResource("drawable:my_location_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/my_location_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_405_809_069)
internal val Res.drawable.my_location_fill_24px: DrawableResource by lazy {
      DrawableResource("drawable:my_location_fill_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/my_location_fill_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_885_445_299)
internal val Res.drawable.navigation_24px: DrawableResource by lazy {
      DrawableResource("drawable:navigation_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/navigation_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(145_126_873)
internal val Res.drawable.settings_24px: DrawableResource by lazy {
      DrawableResource("drawable:settings_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/settings_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_967_531_556)
internal val Res.drawable.speed_24px: DrawableResource by lazy {
      DrawableResource("drawable:speed_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/speed_24px.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("arrow_back_24px", Res.drawable.arrow_back_24px)
  map.put("arrow_drop_down_24px", Res.drawable.arrow_drop_down_24px)
  map.put("brightness_auto_24px", Res.drawable.brightness_auto_24px)
  map.put("check_24px", Res.drawable.check_24px)
  map.put("chevron_left_24px", Res.drawable.chevron_left_24px)
  map.put("chevron_right_24px", Res.drawable.chevron_right_24px)
  map.put("dark_mode_24px", Res.drawable.dark_mode_24px)
  map.put("delete_24px", Res.drawable.delete_24px)
  map.put("editable_marker_pin", Res.drawable.editable_marker_pin)
  map.put("filter_center_focus_24px", Res.drawable.filter_center_focus_24px)
  map.put("light_mode_24px", Res.drawable.light_mode_24px)
  map.put("location_disabled_24px", Res.drawable.location_disabled_24px)
  map.put("location_searching_24px", Res.drawable.location_searching_24px)
  map.put("map_24px", Res.drawable.map_24px)
  map.put("my_location_24px", Res.drawable.my_location_24px)
  map.put("my_location_fill_24px", Res.drawable.my_location_fill_24px)
  map.put("navigation_24px", Res.drawable.navigation_24px)
  map.put("settings_24px", Res.drawable.settings_24px)
  map.put("speed_24px", Res.drawable.speed_24px)
}
